import { makePaymentDirectivesRepository } from 'shared/infra/repositories';

import { FetchDirectivesUseCase } from './implementations/FetchDirectivesUseCase';

let instance: FetchDirectivesUseCase | null = null;

export default function makeFetchDirectivesUseCase() {
  if (!instance) {
    const repository = makePaymentDirectivesRepository();

    instance = new FetchDirectivesUseCase(repository);
  }

  return instance;
}
